export default "__VITE_ASSET__BaeYM47a__"